module.exports = __webpack_public_path__ + "static/media/desert2.ec6fe5da.png";